import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'

export const useDownloadMyEstimatePdfMutation = () =>
  useMutation({
    mutationFn: async (responseId: string): Promise<Blob> => {
      const response = await apiClient.client.get<Blob>(
        `/me/estimate-responses/${responseId}/pdf`,
        { responseType: 'blob' }
      )
      return response.data
    },
  })
